import I18n from 'i18n-js';
I18n.translations || (I18n.translations = {});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "autoflow": {
    "next": "Next"
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Facebook Job saved successfully"
      },
      "google": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Google Jobs saved successfully"
      },
      "landing_page": {
        "add_url": "Add a URL",
        "cancel": "Cancel",
        "custom_landing_page_description": "Generate new URLs and assign a source name per URL. Candidates who complete pre-screening on the URL will be tracked with your customized source name. Common source names are site name and assigned recruiter name, event name.",
        "custom_landing_page_title": "Customize the Landing Page Source",
        "custom_source_label": "Source Name",
        "date_created": "Date Created",
        "invalid_url": "Invalid Redirect URL",
        "landing_pages": "Landing Pages",
        "landing_pages_desc": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "redirect_after": "Redirect After",
        "redirect_url": "Redirect URL",
        "refresh_rate_min_error": "Refresh Rate must be at least 1 second",
        "reload_redirect": "Redirect/Reload",
        "save_success": "Landing page saved successfully",
        "seconds": "Seconds",
        "source_placeholder": "Ex. Washington Site",
        "source_title": "Track a custom source",
        "url_copy": "URL copied to clipboard"
      },
      "lead_ads": {
        "delete_success": "Lead Ad deleted successfully",
        "save_success": "Lead Ad added successfully"
      },
      "messenger": {
        "copy_url": "Copy URL",
        "create_messenger_source_url": "Create URL",
        "create_messenger_source_url_success": "Messenger URL was created successfully",
        "default_input_source_value": "Source",
        "default_select_option_value": "Select...",
        "facebook_pages": "Facebook Pages",
        "messenger_link": "Messenger Link",
        "messenger_source_url_description": "Leads that use this Messenger URL will be tracked with this source.",
        "messenger_source_url_title": "Track a custom source in Messenger URL",
        "page_title": "Facebook Page",
        "previously_created_messenger_urls": "Previously created Messenger URLs",
        "previously_created_messenger_urls_description": "Here are all the previously created Messenger URLs for this campaign.",
        "select_pages": "Select the Facebook Pages to list this campaign on Messenger, then click Save to apply your changes",
        "source_label": "Source",
        "source_title": "Track a custom source"
      },
      "sms": {
        "apply_number": "Candidates can apply to this job by sending an SMS to this dedicated phone number",
        "text_copied": "Text copied to clipboard",
        "with_format": "with the following format"
      },
      "tecoloco_jobs": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Tecoloco Jobs saved successfully"
      }
    }
  },
  "campaigns": {
    "edit": {
      "form": {
        "job_type": "Job type",
        "job_type_options": {
          "contract": "Contract",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "location": "Location",
        "salary": "Salary"
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Share"
        }
      }
    },
    "buttons": {
      "proceed": "Proceed",
      "submit": "Submit"
    },
    "options": {
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATS APP"
    },
    "upload": "Upload"
  },
  "companies": {
    "settings": {
      "team": {
        "role_permissions": {
          "manager": "Manager"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about 1 hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about 1 month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about 1 year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost 1 year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than 1 second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over 1 year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "1 day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "1 second",
        "other": "less than %{count} seconds"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Seconds",
      "year": "Year"
    }
  },
  "eos": {
    "campaign": {
      "label": {
        "add_button": "Add a Button",
        "banner": "Banner",
        "call_to_action": "Call to Action",
        "cancel": "Cancel",
        "completion_message": "Completion Message",
        "copy": "Copy",
        "create_button": "Create Button",
        "crop": "Crop",
        "facebook_pixel_id": "Facebook Pixel ID",
        "google_tag_container_id": "Google Tag Manager Container ID",
        "landing_page_type": "Landing Page Type",
        "landing_page_url": "Landing Page URL",
        "new_landing_page_design": "New Landing Page design",
        "redirect_url": "Redirect URL",
        "text_displayed": "Text displayed"
      },
      "text": {
        "active_cta_limit": "Active button count limit reached.",
        "add_cta": "Add Call to Action buttons to the Completion Screen",
        "add_cta_info": "Call to Action buttons on Landing Page completion screens to redirect applicants to your socials or to perform an action. You can create multiple buttons, but only three can be active at a time.",
        "allowed_banner_files": "Allowed file types: jpg, png, jpeg. Max 2MB.",
        "apply_new_design": "Apply the new landing page design to this campaign.",
        "banner_notice": "You are using the default banner for all your campaigns from Company Settings.",
        "banner_required": "Banner is required.",
        "button_limit_reached": "Button count hard limit reached",
        "click_on_dropdown": "Click on dropdown to read more about each type.",
        "custom_source_guide": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "default_banner_use": "If no banner is added and a Default Banner is available in Company Settings, the Default Banner will be used.",
        "incomplete_details": "Incomplete details",
        "internal_server_error": "Sorry, we are experiencing an internal server problem. Please try again later.",
        "invalid_url": "%{url} is not a valid URL",
        "landing_page_type": {
          "multiple": {
            "description": "Questions are displayed one screen at a time.",
            "title": "One Question Per Screen"
          },
          "single": {
            "description": "All questions are displayed on a single page.",
            "title": "Long Form"
          }
        },
        "landing_pages": "Landing Pages",
        "nothing_to_update": "Nothing to update.",
        "page_type_notice": "You have already selected a %{type} type for all your campaigns from Company Settings.",
        "recommended_banner": "2100px x 1100px recommended.",
        "shown_end_form": "Shown at the end of the form.",
        "updated_successfully": "Updated successfully."
      }
    },
    "company": {
      "label": {
        "color_theme": "Color theme",
        "default_banner": "Default Banner",
        "primary": "Primary",
        "secondary": "Secondary",
        "shade": "Shade"
      },
      "text": {
        "apply_new_design": "Apply the new landing page design to all campaigns.",
        "apply_page_type": "Apply the Landing Page Type to all Campaigns. If selected, option will be disabled in Campaign Settings.",
        "default_banner": "If no banner is uploaded to a campaign, the Default Banner will be used.",
        "default_banner_use": "Use Default Banner across all campaigns. If selected, option will be disabled in Campaign Settings.",
        "enter_custom_color": "Alternatively, you can enter HEX code values in the Primary and Secondary text fields.",
        "select_color_palette": "Select colors for the Landing Page color theme using the palette and sliders below."
      }
    },
    "landing_page": {
      "communication_channels": {
        "email": "Email",
        "errors": {
          "field_required": "%{field} required."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Besides email, what is the best way to get a hold of you and update you on on the next steps?",
        "whatsapp": "WhatsApp"
      },
      "label": {
        "audio": "Audio",
        "click_download": "Click here to download",
        "contract": "Contract",
        "copy_it": "Copy it",
        "email": "Email",
        "email_it": "Email it",
        "error": "Error",
        "facebook": "Facebook",
        "file_upload": "File Upload",
        "first_name": "First Name",
        "fixed_term": "Fixed Term",
        "full_time": "Full time",
        "get_started": "Get Started",
        "internship": "Internship",
        "job_type": "Job Type",
        "last_name": "Last Name",
        "location": "Location",
        "new_recording": "New Recording",
        "next": "Next",
        "part_time": "Part time",
        "pause": "Pause",
        "phone_number": "Phone Number",
        "picture": "Picture",
        "play": "Play",
        "play_recording": "Play Recording",
        "post_it": "Post it",
        "probationary": "Probationary",
        "proceed": "Proceed",
        "project": "Project",
        "record_now": "Record Now",
        "regular": "Regular",
        "retake_picture": "Retake Picture",
        "retry": "Retry",
        "salary": "Salary",
        "save": "Save",
        "seasonal": "Seasonal",
        "share": "Share",
        "share_it": "Share it",
        "snap_photo": "Snap Photo",
        "start_camera": "Start Camera",
        "start_recording": "Start Recording",
        "stop": "Stop",
        "stop_recording": "Stop Recording",
        "submit": "Submit",
        "take_picture": "Take a picture",
        "text": "Text",
        "tweet_it": "Tweet it",
        "undisclosed": "Undisclosed",
        "upload": "Upload",
        "view_sample": "View Sample",
        "volunteer": "Volunteer",
        "warning": "Warning",
        "whatsapp": "WhatsApp",
        "your_progress": "Your progress"
      },
      "text": {
        "about_company": "About %{company}",
        "about_our_company": "About our company",
        "application_invalid": "Invalid application",
        "camera_not_permitted": "Camera access is blocked.",
        "close_warning": "In case of leaving this questionnaire before its completion, it can be completed on a later attempt, but no previously provided answer/record will be visible or editable.",
        "completion_message": "You have successfully completed and submitted your application for %{job}. Thank you!",
        "contact_channel": "What is the best way to contact me about my application?",
        "copied_succesfully": "Copied successfully",
        "generic_browser_error": "Unable to record media. Make sure that there is an accessible media capture device and you are using the latest and modern browser for best experience.",
        "instructions": "Instruction(s): %{text}",
        "job_type_options": {
          "contract": "Contract",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "mic_not_permitted": "Microphone access is blocked.",
        "min_max_char": "Entry should be %{min} character(s) minimum and %{max} characters maximum",
        "no_camera": "No camera available.",
        "no_media_device": "No accessible media device.",
        "no_mic": "No microphone available.",
        "no_supported_mimetype": "There are no supported MIME media type in this browser and recording quality might suffer. Try switching to another browser or device.",
        "our_social_media": "Our Social Media",
        "privacy_policy": "I agree to the <a target=\"_b\" href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_talkpush": "I agree to the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_url": "https://talkpush.com/privacy/",
        "question_progress": "%{current} of %{size}",
        "rate_your_experience": "Rate your experience",
        "receive_updates": "I want to receive updates through SMS, Facebook, Messenger or Whatsapp.",
        "remote_types": {
          "fully_remote": "Fully Remote",
          "temporarily_remote": "Temporarily Remote",
          "wfh_flexible": "WFH Flexible"
        },
        "salary_types": {
          "annually": "Annually",
          "biweekly": "Biweekly",
          "daily": "Daily",
          "hourly": "Hourly",
          "monthly": "Monthly",
          "one-time": "One-time",
          "weekly": "Weekly"
        },
        "share_with_network": "Share with your network",
        "size_of_mb": "%{size} of 20mb",
        "thank_you": "Thank you",
        "trouble_playing_response": "Having trouble playing this response?",
        "upload": {
          "error": "Some files cannot be uploaded.",
          "file_invalid_type": "File format should be .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "The file size should be less than 10MB."
        },
        "upload_failed": "There was an error while uploading your response. Please try again.",
        "video_limit": "The maximum video response length is 1 minute."
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "new_recording": "New Recording",
        "phone_number": "Phone Number",
        "record_now": "Record Now",
        "start_camera": "Start Camera",
        "stop_recording": "Stop Recording",
        "take_picture": "Take a picture"
      },
      "notes": {
        "video_limit": "The maximum video response length is 1 minute."
      },
      "show": {
        "about": "About"
      },
      "success": {
        "answers_message": "Thank you for submitting your responses. We have received your application.",
        "title": "Thank you"
      }
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Add Image",
      "apply": "Apply",
      "change_image": "Change Image",
      "copy": "Copy",
      "save": "Save",
      "select_page_helper": "Linking Facebook page(s) means anyone who chats to your bot can see this campaign. For this campaign not to appear on the chatbot, leave this field empty.\nBelow you can see all the messenger interview links to direct candidates directly to the chatbot interview, this is available even if the facebook page is not linked to this campaign (indicated by the lock icon).",
      "view_job_description": "View Job Description"
    },
    "google": {
      "google_job": "Google Jobs (beta)",
      "job_par": {
        "best_practice": "best_practices",
        "first": "Jobs that are listed on Google will appear directly in the Google search results.",
        "head": "Enable Google indexing of the Landing Page",
        "help_center": "our help center",
        "second": "Applicants that click on these job listings are forwarded to the Talkpush Job Landing Page, where they can choose to apply and immediately complete the screening questions. You can learn more about it in",
        "third": "If your job does not appear in the Google Job posting please make sure you are following those"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Requires job title, country, region, and long description to be filled out."
      }
    },
    "landing": {
      "copy": "Copy",
      "first": "Landing Page URL",
      "save": "Save"
    },
    "lead": {
      "associated": "Associated facebook page",
      "authorize": "You need to associate your facebook page to our facebook app (Talkpush Bot) to process generated leads",
      "failed_duplicate": "This Lead Ad ID is already being used by %{campaign}",
      "failed_no_fb_page": "Please associate this company to a facebook page first",
      "how_to": "How to Setup lead ad for Talkpush",
      "id": "Lead Ad ID",
      "list": "List of Lead Ads ID",
      "login": "Login with Facebook",
      "submit": "Submit",
      "success_add": "Lead successfully added",
      "success_delete": "Lead successfully deleted",
      "title": "Lead Ads"
    },
    "spreadsheet": {
      "authorize": "Authorize Access",
      "create_par": "Create a Google form",
      "erp": "Employee Referral Program",
      "googlesheet": "Google spreadsheet URL",
      "here": "here",
      "ncs": "Normal Candidate Submission",
      "paste": "Paste your google spreadsheet‚Äôs link here.",
      "please": "Please input a valid Google Spreadsheet URL which is connected to your Google Form",
      "step1": "Step 1",
      "step2": "Step 2",
      "step2_par": "Create a Google Spreadsheet containing the responses of the Google Form above",
      "step3": "Step 3",
      "step3_par": "Copy paste the Google Spreadsheet's URL to the field below and Click on Authorize Access",
      "step4": "Step 4",
      "step4_par": "Confirm your Google Account credentials to provide Talkpush with access to the Spreadsheet",
      "title": "Spreadsheet",
      "two_ex": "Here are two examples",
      "wiki": "Wiki",
      "wiki_par": "following instructions outlined on our"
    },
    "tecoloco": {
      "job_par": {
        "first": "Jobs that are listed in Tecoloco will appear in the Tecoloco feed.",
        "head": "Advertise the job opening on Tecoloco Jobs",
        "help_center": "our help center",
        "second": "Candidates who apply to these job listings are forwarded to the Talkpush Job Landing Page, where they can apply and immediately complete the screening questions. You can learn more about it in"
      },
      "tecoloco_jobs": "Tecoloco Jobs"
    }
  },
  "job_landing_page": {
    "application_invalid": "Invalid application"
  },
  "jobs": {
    "salary_types": {
      "annually": "Annually",
      "biweekly": "Biweekly",
      "daily": "Daily",
      "hourly": "Hourly",
      "monthly": "Monthly",
      "one-time": "One-time",
      "weekly": "Weekly"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy/",
  "setup_questions": {
    "question_types": {
      "audio": "Audio",
      "text": "Text"
    }
  },
  "time": {
    "am": "AM",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "pm": "PM"
  }
});
I18n.translations["es"] = I18n.extend((I18n.translations["es"] || {}), {
  "autoflow": {
    "next": "Siguiente"
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Trabajo de Facebook guardado con éxito"
      },
      "google": {
        "fill_out": "Complete todos los datos requeridos en la Configuración de la campaña",
        "save_success": "Google Jobs se guardó correctamente"
      },
      "landing_page": {
        "add_url": "Agregar un URL",
        "cancel": "Cancelar",
        "custom_landing_page_description": "Genere nuevas URL y asigne una fuente por URL. Los candidatos que completen la preselección en la URL serán rastreados con la fuente personalizada. Los nombres de fuentes comunes son el nombre del sitio y el nombre del reclutador asignado, el nombre del evento.",
        "custom_landing_page_title": "Personalizar la fuente de la página de destino",
        "custom_source_label": "Nombre de la Fuente",
        "date_created": "Creada",
        "invalid_url": "URL de redireccionamiento no válido",
        "landing_pages": "Páginas de destino",
        "landing_pages_desc": "Por defecto, la página de destino se registra como \"Landing Page\" en el punto de datos de origen. Abajo, puede nombrar una URL de página de destino como fuente personalizada.",
        "redirect_after": "Redirigir Después",
        "redirect_url": "Enlace de redireccionamiento",
        "refresh_rate_min_error": "La frecuencia de actualización debe ser de al menos 1 segundo",
        "reload_redirect": "Redirigir Después",
        "save_success": "La página de destino se guardó con éxito",
        "seconds": "Segundos",
        "source_placeholder": "Ej. Sitio en Washington ",
        "source_title": "Fuente Personalizada",
        "url_copy": "URL copiada al portapapeles"
      },
      "lead_ads": {
        "delete_success": "Lead eliminado con éxito",
        "save_success": "Lead agregado con éxito"
      },
      "messenger": {
        "copy_url": "Copiar URL",
        "create_messenger_source_url": "Crear URL",
        "create_messenger_source_url_success": "URL de Messenger fue creado exitosamente",
        "default_input_source_value": "Fuente",
        "default_select_option_value": "Seleccionar...",
        "facebook_pages": "Páginas de Facebook",
        "messenger_link": "Link de Messenger",
        "messenger_source_url_description": "Los candidatos que usen este URL de Messenger serán rastreados con esta fuente.",
        "messenger_source_url_title": "Rastrear fuente personalizada en un URL de Messenger",
        "page_title": "Pagina de Facebook",
        "previously_created_messenger_urls": "URLs de Messenger creados previamente",
        "previously_created_messenger_urls_description": "Aquí están todos los URL de Messenger creados previamente para esta campaña",
        "select_pages": "Seleccione las páginas de Facebook que le gustaría que muestren esta campaña en Messenger. Luego, haga clic en \"Guardar\" para aplicar los cambios",
        "source_label": "Fuente",
        "source_title": "Rastrea una fuente personalizada"
      },
      "sms": {
        "apply_number": "Los candidatos pueden postularse a este trabajo enviando un SMS a este número de teléfono dedicado",
        "text_copied": "Texto copiado al portapapeles",
        "with_format": "con el siguiente formato"
      },
      "tecoloco_jobs": {
        "fill_out": "Complete todos los datos requeridos en la Configuración de la campaña",
        "save_success": "Trabajos de Tecoloco guardados con éxito"
      }
    }
  },
  "campaigns": {
    "edit": {
      "form": {
        "job_type": "Tipo de Posición",
        "job_type_options": {
          "contract": "Contrato",
          "fixed_term": "Término fijo",
          "full_time": "Tiempo Completo",
          "internship": "Practicas",
          "part_time": "Medio Tiempo",
          "probationary": "De prueba",
          "project": "Proyecto",
          "regular": "Regular",
          "seasonal": "Estacional",
          "volunteer": "Voluntarios"
        },
        "location": "Ubicación",
        "salary": "Salario"
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Compartir"
        }
      }
    },
    "buttons": {
      "proceed": "Aplicar a este empleo",
      "submit": "Envíar"
    },
    "options": {
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATSAPP"
    },
    "upload": "Subir"
  },
  "companies": {
    "settings": {
      "team": {
        "role_permissions": {
          "manager": "Administrador"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "dom",
      "lun",
      "mar",
      "mié",
      "jue",
      "vie",
      "sáb"
    ],
    "abbr_month_names": [
      null,
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic"
    ],
    "day_names": [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%-d/%-m/%Y",
      "long": "%-d de %B de %Y",
      "short": "%-d de %b"
    },
    "month_names": [
      null,
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "alrededor de 1 hora",
        "other": "alrededor de %{count} horas"
      },
      "about_x_months": {
        "one": "alrededor de 1 mes",
        "other": "alrededor de %{count} meses"
      },
      "about_x_years": {
        "one": "alrededor de 1 año",
        "other": "alrededor de %{count} años"
      },
      "almost_x_years": {
        "one": "casi 1 año",
        "other": "casi %{count} años"
      },
      "half_a_minute": "medio minuto",
      "less_than_x_minutes": {
        "one": "menos de 1 minuto",
        "other": "menos de %{count} minutos"
      },
      "less_than_x_seconds": {
        "one": "menos de 1 segundo",
        "other": "menos de %{count} segundos"
      },
      "over_x_years": {
        "one": "más de 1 año",
        "other": "más de %{count} años"
      },
      "x_days": {
        "one": "1 día",
        "other": "%{count} días"
      },
      "x_minutes": {
        "one": "1 minuto",
        "other": "%{count} minutos"
      },
      "x_months": {
        "one": "1 mes",
        "other": "%{count} meses"
      },
      "x_seconds": {
        "one": "1 segundo",
        "other": "%{count} segundos"
      }
    },
    "prompts": {
      "day": "Día",
      "hour": "Hora",
      "minute": "Minutos",
      "month": "Mes",
      "second": "Segundos",
      "year": "Año"
    }
  },
  "eos": {
    "campaign": {
      "label": {
        "add_button": "Agregar un botón",
        "banner": "Banner\n",
        "call_to_action": "Llamado a la Acción",
        "cancel": "Cancelar",
        "completion_message": "Mensaje de Finalización\n",
        "copy": "Copiar",
        "create_button": "Crear botón",
        "crop": "Recortar",
        "facebook_pixel_id": "ID de Facebook Pixel ",
        "google_tag_container_id": "ID del contenedor del administrador de etiquetas de Google",
        "landing_page_type": "Tipo de Página de Destino",
        "landing_page_url": "URL del Landing Page",
        "new_landing_page_design": "Nueva Página de Destino",
        "redirect_url": "Enlace de redireccionamiento",
        "text_displayed": "Texto desplegado"
      },
      "text": {
        "active_cta_limit": "Se alcanzó el límite de botones activos. ",
        "add_cta": "Agregar botones de Llamado a la Acción a la Pantalla de Finalización",
        "add_cta_info": "Botones de Llamado a la acción en las Pantallas de finalización y así redirigir a los aplicantes a tus redes sociales o para realizar una acción. Puedes crear múltiples botones, pero solo tres pueden estar activos a la vez. ",
        "allowed_banner_files": "Tipos de archivos permitidos: jpg, png, jpeg. 2 MB Máx.",
        "apply_new_design": "Aplicar la nueva Página de Destino a esta campaña. ",
        "banner_notice": "Estás utilizando el Banner predeterminado en todas las campañas desde la Configuración de la Empresa. ",
        "banner_required": "Este campo es requerido.",
        "button_limit_reached": "Se alcanzó el límite de botones activos.",
        "click_on_dropdown": "Haz clic en el menú desplegable para leer más sobre cada tipo.",
        "custom_source_guide": "Por defecto, la página de destino se registra como \"Landing Page\" en el punto de datos de origen. Abajo, puede nombrar una URL de página de destino como fuente personalizada.",
        "default_banner_use": "Si no se agrega ningún banner y hay un Banner Predeterminado disponible en la Configuración de Empresa, se utilizará el Banner Predeterminado.",
        "incomplete_details": "Detalles incompletos.",
        "internal_server_error": "Lo sentimos, estamos experimentando problemas con nuestro servidor. Por favor, inténtelo de nuevo más tarde.",
        "invalid_url": "%{url} no es una URL válida. ",
        "landing_page_type": {
          "multiple": {
            "description": "Se muestran las preguntas una a la vez. ",
            "title": "Una Pregunta por Pantalla"
          },
          "single": {
            "description": "Todas las preguntas se muestran en una sola página. ",
            "title": "Formulario"
          }
        },
        "landing_pages": "Páginas de destino",
        "nothing_to_update": "Nada que actualizar.",
        "page_type_notice": "Ya has seleccionado el tipo %{type} para todas las campañas desde Configuración de la Empresa.",
        "recommended_banner": "2100px x 1100px recomendado.",
        "shown_end_form": "Se muestra al final del formulario.",
        "updated_successfully": "Actualizado con éxito."
      }
    },
    "company": {
      "label": {
        "color_theme": "Color de Tema",
        "default_banner": "Banner Predeterminado",
        "primary": "Primario",
        "secondary": "Secundario",
        "shade": "Tono"
      },
      "text": {
        "apply_new_design": "Aplicar la nueva Página de Destino a todas las campañas.",
        "apply_page_type": "Aplicar el Tipo de Página de Destino a todas las campañas. Si se selecciona, la opción de modificar el tipo estará deshabilitada en la configuración de la campaña. ",
        "default_banner": "Si no se carga ningún banner en una campaña, se utilizará el Banner Predeterminado.",
        "default_banner_use": "Utilizar el Banner Predeterminado en todas las campañas. Si se selecciona, la opción se desactivará en la configuración de la campaña.",
        "enter_custom_color": "Alternativamente, puede ingresar valores de código HEX en los campos de texto Principal y Secundario.",
        "select_color_palette": "Seleccione los colores para el tema de color de la página de destino usando la paleta y los controles deslizantes a continuación."
      }
    },
    "landing_page": {
      "communication_channels": {
        "email": "Correo electrónico",
        "errors": {
          "field_required": "%{field} es requerido."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Además del email, ¿Cuál es la mejor manera para notificarte los pasos a seguir?",
        "whatsapp": "WhatsApp"
      },
      "label": {
        "audio": "Audio",
        "click_download": "Haga click aquí para descargar",
        "contract": "Contrato",
        "copy_it": "Cópialo",
        "email": "Correo electrónico",
        "email_it": "Envíalo por Email",
        "error": "Error",
        "facebook": "Facebook",
        "file_upload": "Subir archivo",
        "first_name": "Nombre",
        "fixed_term": "Término fijo",
        "full_time": "Tiempo Completo",
        "get_started": "Empezar",
        "internship": "Pasantía",
        "job_type": "Tipo de Posición",
        "last_name": "Apellidos",
        "location": "Ubicación",
        "new_recording": "Nueva grabación",
        "next": "Siguiente",
        "part_time": "Medio Tiempo",
        "pause": "Pausar",
        "phone_number": "Número de teléfono",
        "picture": "Imagen",
        "play": "Reproducir",
        "play_recording": "Reproducir grabación",
        "post_it": "Publícalo",
        "probationary": "De prueba",
        "proceed": "Proceder",
        "project": "Proyecto",
        "record_now": "Grabar ahora",
        "regular": "Regular",
        "retake_picture": "Volver a tomar foto",
        "retry": "Reintentar",
        "salary": "Salario",
        "save": "Guardar",
        "seasonal": "Temporal",
        "share": "Compartir",
        "share_it": "Compártelo",
        "snap_photo": "Tomar foto",
        "start_camera": "Iniciar Cámara",
        "start_recording": "Empezar a grabar",
        "stop": "Detener",
        "stop_recording": "Para de grabar",
        "submit": "Envíar",
        "take_picture": "Toma una foto",
        "text": "Texto",
        "tweet_it": "Tuitéalo",
        "undisclosed": "No revelado",
        "upload": "Cargar",
        "view_sample": "Ver muestra",
        "volunteer": "Voluntarios",
        "warning": "Alerta",
        "whatsapp": "WhatsApp",
        "your_progress": "Progreso"
      },
      "text": {
        "about_company": "Acerca de %{company}",
        "about_our_company": "Sobre nuestra compañía",
        "application_invalid": "Aplicación  no válida",
        "camera_not_permitted": "El acceso a la cámara está bloqueado.",
        "close_warning": "En caso de abandonar este cuestionario antes de enviarlo, podrá completarlo en un intento posterior, pero ninguna respuesta/registro previo será visible o editable.",
        "completion_message": "Has completado y enviado con éxito tu aplicación para %{job}. ¡Gracias!",
        "contact_channel": "¿Cuál es la mejor manera de contactarme? ",
        "copied_succesfully": "Copiado con éxito",
        "generic_browser_error": "No se puede grabar multimedia. Asegúrate de que haya un dispositivo de captura de multimedia y que estés utilizando el navegador actualizado para tener la mejor experiencia. ",
        "instructions": "Instrucciones: %{text}",
        "job_type_options": {
          "contract": "Contrato",
          "fixed_term": "Término fijo",
          "full_time": "Tiempo Completo",
          "internship": "Pasantía",
          "part_time": "Medio Tiempo",
          "probationary": "De prueba",
          "project": "Proyecto",
          "regular": "Regular",
          "seasonal": "Temporal",
          "volunteer": "Voluntarios"
        },
        "mic_not_permitted": "El acceso al micrófono está bloqueado.",
        "min_max_char": "La respuesta debe contener entre %{min} y %{max} caracteres. ",
        "no_camera": "No hay cámara disponible.",
        "no_media_device": "Ningún dispositivo multimedia accesible.",
        "no_mic": "No hay micrófono disponible.",
        "no_supported_mimetype": "No hay ningún tipo de medio MIME admitido en este navegador y la calidad de la grabación puede verse afectada. Intenta cambiar a otro navegador o dispositivo.",
        "our_social_media": "Nuestras Redes Sociales",
        "privacy_policy": "Acepto y estoy de acuerdo con la  <a target=\"_b\" href=\"%{policy_url}\">Política de Privacidad</a> de %{company} y la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Política de Privacidad</a> del proveedor del servicio.",
        "privacy_policy_talkpush": "Acepto la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Política de Privacidad</a> del proveedor del servicio. ",
        "privacy_policy_url": "https://talkpush.com/privacy/",
        "question_progress": "%{current} de %{size}",
        "rate_your_experience": "Califica tu experiencia",
        "receive_updates": "Quiero recibir actualizaciones a través de SMS, Facebook, Messenger o WhatsApp.\n",
        "remote_types": {
          "fully_remote": "Totalmente Remoto",
          "temporarily_remote": "Temporalmente Remoto",
          "wfh_flexible": "Trabajo desde Casa Flexible"
        },
        "salary_types": {
          "annually": "Anual",
          "biweekly": "Quincenal",
          "daily": "Diario",
          "hourly": "Por hora",
          "monthly": "Mensual",
          "one-time": "Una vez",
          "weekly": "Semanal"
        },
        "share_with_network": "Comparte con tu red",
        "size_of_mb": "%{size} de 20mb",
        "thank_you": "Gracias",
        "trouble_playing_response": "¿Tiene problemas para reproducir esta respuesta?",
        "upload": {
          "error": "Algunos archivos no se pueden cargar.",
          "file_invalid_type": "El formato del archivo debe ser .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "El tamaño del archivo debe ser inferior a 10 MB."
        },
        "upload_failed": "Hubo un error al enviar su respuesta. Inténtalo de nuevo.",
        "video_limit": "La duración máxima de la respuesta de video es de 1 minuto."
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "Correo electrónico",
        "first_name": "Nombre",
        "last_name": "Apellidos",
        "new_recording": "Nueva grabación",
        "phone_number": "Número de teléfono",
        "record_now": "Grabar ahora",
        "start_camera": "Iniciar Cámara",
        "stop_recording": "Para de grabar",
        "take_picture": "Toma una foto"
      },
      "notes": {
        "video_limit": "La duración máxima de la respuesta de video es de 1 minuto."
      },
      "show": {
        "about": "Acerca de"
      },
      "success": {
        "answers_message": "Gracias por enviar sus respuestas. Hemos recibido su aplicación.",
        "title": "Gracias"
      }
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Añadir imagen",
      "apply": "Aplicar",
      "change_image": "Cambiar imagen",
      "copy": "Copiar",
      "save": "Guardar",
      "select_page_helper": "Ligar una o más páginas de Facebook significa que cualquiera que hable con su bot puede ver esta campaña. Para que esta campaña no aparezca en el chatbot, deje este campo vacío.",
      "view_job_description": "Ver descripción"
    },
    "google": {
      "google_job": "Google Jobs (beta)",
      "job_par": {
        "best_practice": "mejores prácticas",
        "first": "Las posiciones que se indicen en Google aparecerán directamente en los resultados de búsqueda de Google.",
        "head": "Habilitar que Google indice el Landing Page",
        "help_center": "nuestro centro de ayuda",
        "second": "Los aplicantes que accedan a estos resultados en Google serán redirigidos al Landing page de Talkpush, donde pueden aplicar y completar inmediatamente las preguntas iniciales. Puede aprender más al respecto en",
        "third": "Si su puesto de trabajo no aparece en las publicaciones de Google Job, por favor asegúrese de seguir estas"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Require que se completen el título, el país, y la descripción larga de la posición."
      }
    },
    "landing": {
      "copy": "Copiar",
      "first": "URL del Landing Page",
      "save": "Guardar"
    },
    "lead": {
      "associated": "Página de Facebook asociada",
      "authorize": "Autorizar la Talkpush Lead add app para acceder a leads generados en su página de Facebook",
      "failed_duplicate": "%{campaign} ya está utilizando este ID de Lead Ad",
      "failed_no_fb_page": "Por favor primero asocie esta empresa a una página de Facebook",
      "how_to": "Como configurar un lead ad para Talkpush",
      "id": "ID del Lead Ad",
      "list": "Lista de ID de Lead Ads",
      "login": "Iniciar sesión con Facebook",
      "submit": "Envíar",
      "success_add": "Lead agregado con éxito",
      "success_delete": "Lead eliminado con éxito",
      "title": "Lead Ads"
    },
    "spreadsheet": {
      "authorize": "Autorizar acceso",
      "create_par": "Crear un formulario de Google",
      "erp": "Programa de referidos",
      "googlesheet": "URL de hoja de cálculo de Google",
      "here": "aquí",
      "ncs": "Envío normal de candidatos",
      "paste": "Pegue aquí el link the su hoja de cálculo de Google",
      "please": "Por favor ingrese una URL de hoja de cálculo de Google válida que este conectada con su formulario de Google",
      "step1": "Paso 1",
      "step2": "Paso 2",
      "step2_par": "Crear un hoja de cálculo de Google que contenga las respuestas del formulario de Google mencionado arriba",
      "step3": "Paso 3",
      "step3_par": "Copiar y pegar el URL de la hoja de cálculo de Google en el campo de abajo y hacer click en \"autorizar acceso\"",
      "step4": "Paso 4",
      "step4_par": "Confirmar las credenciales de su cuenta de Google para proveer a Talkpush acceso a la hoja de cálculo",
      "title": "Hoja de cálculo",
      "two_ex": "Aquí hay dos ejemplos",
      "wiki": "Wiki",
      "wiki_par": "siguendo instrucciones dadas en nuestro"
    },
    "tecoloco": {
      "job_par": {
        "first": "Los trabajos que se enumeran en Tecoloco aparecerán enlos resultados de búsqueda de Tecoloco.",
        "head": "Anunciar este puesto de trabajo en Tecoloco",
        "help_center": "nuestro centro de ayuda",
        "second": "Los candidatos que se postulan para estas posiciones de trabajo son redirigidos a la página de Talkpush, donde pueden postularse y completar de inmediato las preguntas de selección. Puede obtener más información al respecto en"
      },
      "tecoloco_jobs": "Empleos en Tecoloco"
    }
  },
  "job_landing_page": {
    "application_invalid": "Aplicación inválida"
  },
  "jobs": {
    "salary_types": {
      "annually": "Anual",
      "biweekly": "Quincenal",
      "daily": "Diariamente",
      "hourly": "Por hora\n",
      "monthly": "Mensual",
      "one-time": "Una vez",
      "weekly": "Semanal"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "mil millones",
          "million": "Millón",
          "quadrillion": "mil billones",
          "thousand": "mil",
          "trillion": "Trillón",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n %",
        "precision": 1
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy-applicant/",
  "setup_questions": {
    "question_types": {
      "audio": "Audio",
      "text": "Texto"
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%A, %-d de %B de %Y %H:%M:%S %z",
      "long": "%-d de %B de %Y %H:%M",
      "short": "%-d de %b %H:%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "pm": "pm"
  }
});
I18n.translations["fr"] = I18n.extend((I18n.translations["fr"] || {}), {
  "autoflow": {
    "next": "Suivant"
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Facebook Job enregistré avec succès."
      },
      "google": {
        "fill_out": "Veuillez remplir toutes les données requises dans les paramètres de la campagne.",
        "save_success": "Google Jobs enregistré avec succès."
      },
      "landing_page": {
        "add_url": "Ajouter une URL",
        "cancel": "Annuler",
        "custom_landing_page_description": "Générez de nouvelles URL et attribuez un nom de source à chaque URL. Les candidats qui effectuent une présélection sur l'URL seront suivis avec votre nom de source personnalisé. Les noms de source courants sont le nom du site et le nom du recruteur attribué, le nom de l'événement.",
        "custom_landing_page_title": "Personnaliser la source de la page de destination",
        "custom_source_label": "Nom de la source",
        "date_created": "date de création",
        "invalid_url": "URL de redirection non valide",
        "landing_pages": "Pages de destination",
        "landing_pages_desc": "Par défaut, la page de destination est suivie en tant que \"Page de destination\" dans le point de données source. Vous pouvez nommer une URL de page de destination comme source personnalisée ci-dessous.",
        "redirect_after": "Rediriger après",
        "redirect_url": "Rediriger l'URL",
        "refresh_rate_min_error": "Le taux de rafraîchissement doit être d'au moins 1 seconde.",
        "reload_redirect": "Rediriger / Recharger",
        "save_success": "La page de destination a bien été enregistrée.",
        "seconds": "Secondes",
        "source_placeholder": "Ex. Site de Washington",
        "source_title": "Suivre une source personnalisée",
        "url_copy": "URL copiée dans le presse-papiers"
      },
      "lead_ads": {
        "delete_success": "Annonce principale supprimée avec succès.",
        "save_success": "Annonce principale correctement ajoutée."
      },
      "messenger": {
        "copy_url": "Copier le lien",
        "create_messenger_source_url": "Créer une URL",
        "create_messenger_source_url_success": "L'URL de Messenger a été créée avec succès.",
        "default_input_source_value": "La Source",
        "default_select_option_value": "Sélectionner...",
        "facebook_pages": "Pages Facebook",
        "messenger_link": "Lien Messenger",
        "messenger_source_url_description": "Les candidats qui utilisent cette URL Messenger seront suivis avec cette source.",
        "messenger_source_url_title": "Suivre une source personnalisée dans l'URL de Messenger",
        "page_title": "Page Facebook",
        "previously_created_messenger_urls": "URL Messenger créées précédemment",
        "previously_created_messenger_urls_description": "Voici toutes les URL Messenger créées précédemment pour cette campagne.",
        "select_pages": "Sélectionnez les pages Facebook pour répertorier cette campagne sur Messenger, puis cliquez sur Enregistrer pour appliquer vos modifications.",
        "source_label": "La Source",
        "source_title": "Suivre une source personnalisée"
      },
      "sms": {
        "apply_number": "Les candidats peuvent postuler à ce poste en envoyant un SMS à ce numéro de téléphone dédié.",
        "text_copied": "Texte copié dans le presse-papiers.",
        "with_format": "avec le format suivant"
      },
      "tecoloco_jobs": {
        "fill_out": "Veuillez remplir toutes les données requises dans les paramètres de la campagne.",
        "save_success": "Tecoloco Jobs saved successfully"
      }
    }
  },
  "campaigns": {
    "edit": {
      "form": {
        "job_type": "Type d'emploi",
        "job_type_options": {
          "contract": "Contrat",
          "fixed_term": "Durée déterminée",
          "full_time": "À plein temps",
          "internship": "Stage",
          "part_time": "À temps partiel",
          "probationary": "Probatoire",
          "project": "Projet",
          "regular": "Ordinaire",
          "seasonal": "Saisonnier",
          "volunteer": "Bénévole"
        },
        "location": "Emplacement",
        "salary": "Salaire"
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Partager"
        }
      }
    },
    "buttons": {
      "proceed": "Procéder",
      "submit": "Envoyer"
    },
    "options": {
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATS APP"
    },
    "upload": "Importer"
  },
  "companies": {
    "settings": {
      "team": {
        "role_permissions": {
          "manager": "Responsable"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "dim",
      "lun",
      "mar",
      "mer",
      "jeu",
      "ven",
      "sam"
    ],
    "abbr_month_names": [
      null,
      "jan.",
      "fév.",
      "mar.",
      "avr.",
      "mai",
      "juin",
      "juil.",
      "août",
      "sept.",
      "oct.",
      "nov.",
      "déc."
    ],
    "day_names": [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%d/%m/%Y",
      "long": "%e %B %Y",
      "short": "%e %b"
    },
    "month_names": [
      null,
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "environ une heure",
        "other": "environ %{count} heures"
      },
      "about_x_months": {
        "one": "environ un mois",
        "other": "environ %{count} mois"
      },
      "about_x_years": {
        "one": "environ un an",
        "other": "environ %{count} ans"
      },
      "almost_x_years": {
        "one": "presqu'un an",
        "other": "presque %{count} ans"
      },
      "half_a_minute": "une demi-minute",
      "less_than_x_minutes": {
        "one": "moins d'une minute",
        "other": "moins de %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "moins d'une seconde",
        "other": "moins de %{count} secondes"
      },
      "over_x_years": {
        "one": "plus d'un an",
        "other": "plus de %{count} ans"
      },
      "x_days": {
        "one": "1 jour",
        "other": "%{count} jours"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 mois",
        "other": "%{count} mois"
      },
      "x_seconds": {
        "one": "1 seconde",
        "other": "moins de %{count} secondes"
      }
    },
    "prompts": {
      "day": "Jour",
      "hour": "Heure",
      "minute": "Minute",
      "month": "Mois",
      "second": "Seconde",
      "year": "Année"
    }
  },
  "eos": {
    "campaign": {
      "label": {
        "add_button": "Ajouter un lien",
        "banner": "Bannière",
        "call_to_action": "Prochaine étape",
        "cancel": "Annuler",
        "completion_message": "Message de fin",
        "copy": "Copier",
        "create_button": "Créer un lien",
        "crop": "Recadrer",
        "facebook_pixel_id": "Pixel ID Facebook",
        "google_tag_container_id": "ID de conteneur Google Tag Manager",
        "landing_page_type": "Type de page web",
        "landing_page_url": "URL de la page web",
        "new_landing_page_design": "Design de la page web",
        "redirect_url": "URL de redirection",
        "text_displayed": "Texte affiché"
      },
      "text": {
        "active_cta_limit": "Limite maximum du nombre de liens actifs .",
        "add_cta": "Ajouter liens au dernier écran ",
        "add_cta_info": "Lien écran de fin pour rediriger les candidats vers vos réseaux sociaux ou pour effectuer une action. Vous pouvez créer jusqu’à trois liens à la fois. ",
        "allowed_banner_files": "Types de fichiers autorisés : jpg, png, jpeg. 2 Mo maximum.",
        "apply_new_design": "Utilisez la page web avec le nouveau design pour cette campagne.",
        "banner_notice": "Utiliser la bannière standard, suivant les paramètres de votre compte sur toutes les campagnes.",
        "banner_required": "Ce champ est obligatoire.",
        "button_limit_reached": "Limite de liens atteinte",
        "click_on_dropdown": "Cliquez sur le menu déroulant pour en savoir plus ",
        "custom_source_guide": "Par défaut, la \"page web\" est marquée comme la source. Vous pouvez personnaliser la source ci-dessous.",
        "default_banner_use": "Si aucune bannière n'est ajoutée, la bannière standard sauvegardée dans les paramètres du compte sera utilisée",
        "incomplete_details": "Détails incomplets",
        "internal_server_error": "Désolé, nous rencontrons un problème de serveur interne. Veuillez réessayer plus tard.",
        "invalid_url": "%{url} n'est pas une URL valide",
        "landing_page_type": {
          "multiple": {
            "description": "Une question par écran",
            "title": "Une question par écran"
          },
          "single": {
            "description": "Toutes les questions sont affichées sur une seule page.",
            "title": "Formulaire long"
          }
        },
        "landing_pages": "Pages web",
        "nothing_to_update": "Rien à mettre à jour.",
        "page_type_notice": "Vous avez déjà sélectionné un type %{type} de page web pour toutes vos campagnes dans vos paramètres compte",
        "recommended_banner": "2100px x 1100px recommandé.",
        "shown_end_form": "Affiché à la fin du formulaire.",
        "updated_successfully": "Mis à jour avec succés."
      }
    },
    "company": {
      "label": {
        "color_theme": "Schéma des couleurs",
        "default_banner": "Bannière par défaut",
        "primary": "Primaire",
        "secondary": "Secondaire",
        "shade": "Couleur"
      },
      "text": {
        "apply_new_design": "Utilisez la page web avec le nouveau design pour toutes les campagnes.",
        "apply_page_type": "Par défaut, utilisez ce type de page web pour toutes les campagnes. Cette option peut être désactivée dans les paramètres de chaque campagne.",
        "default_banner": "Si aucune bannière n'est téléchargée dans une campagne, la bannière standard sera utilisée.",
        "default_banner_use": "Utilisez la bannière par défaut dans toutes les campagnes. Si elle est sélectionnée, l'option sera désactivée dans les paramètres de campagne.",
        "enter_custom_color": "Vous pouvez également entrer des valeurs de code HEX dans les champs de texte principal et secondaire.",
        "select_color_palette": "Sélectionnez les couleurs du thème de couleurs de la page d'accueil à l'aide de la palette et des curseurs ci-dessous."
      }
    },
    "landing_page": {
      "communication_channels": {
        "email": "E-mail",
        "errors": {
          "field_required": "%{field} required."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Besides email, what is the best way to get a hold of you and update you on on the next steps?",
        "whatsapp": "WhatsApp"
      },
      "label": {
        "audio": "Réponse audio",
        "click_download": "Cliquez ici pour télécharger",
        "contract": "Contrat",
        "copy_it": "Copier",
        "email": "E-mail",
        "email_it": "Envoyez par e-mail",
        "error": "Erreur",
        "facebook": "Facebook",
        "file_upload": "Télécharger le fichier",
        "first_name": "Prénom",
        "fixed_term": "Durée déterminée",
        "full_time": "À plein temps",
        "get_started": "Commencer",
        "internship": "Stage",
        "job_type": "Type d'emploi",
        "last_name": "Nom",
        "location": "Localisation",
        "new_recording": "Nouvel enregistrement",
        "next": "Suivant",
        "part_time": "À temps partiel",
        "pause": "Pauser",
        "phone_number": "Numéro de téléphone",
        "picture": "Photo",
        "play": "Lire",
        "play_recording": "Lire l'enregistrement",
        "post_it": "Postez-le",
        "probationary": "Probatoire",
        "proceed": "Procéder",
        "project": "Projet",
        "record_now": "Enregistrer maintenant",
        "regular": "Ordinaire",
        "retake_picture": "Reprendre la photo",
        "retry": "Retry",
        "salary": "Salaire",
        "save": "Enregistrer",
        "seasonal": "Saisonnier",
        "share": "Partager",
        "share_it": "Partager",
        "snap_photo": "Photo instantanée",
        "start_camera": "Démarrer la caméra",
        "start_recording": "Commencer l'enregistrement",
        "stop": "Arrêter",
        "stop_recording": "Arrêter d'enregistrer",
        "submit": "Envoyer",
        "take_picture": "Prendre une photo",
        "text": "Texte",
        "tweet_it": "Twitter ",
        "undisclosed": "non dévoilé",
        "upload": "Importer",
        "view_sample": "Afficher",
        "volunteer": "Bénévole",
        "warning": "Attention",
        "whatsapp": "WhatsApp",
        "your_progress": "Etat d'avancement "
      },
      "text": {
        "about_company": "En savoir plus sur %{company}",
        "about_our_company": "Qui somme nous? ",
        "application_invalid": "Candidature invalide",
        "camera_not_permitted": "L'accès à la caméra est bloqué.",
        "close_warning": "In case of leaving this questionnaire before its completion, it can be completed on a later attempt, but no previously provided answer/record will be visible or editable.",
        "completion_message": "Vous avez rempli et soumis avec succès votre candidature pour %{job}. Merci!",
        "contact_channel": "Quel est le  meilleur moyen de me contacter au sujet de ma candidature ?",
        "copied_succesfully": "Copié avec succès",
        "generic_browser_error": "Impossible d'enregistrer le média. Assurez-vous qu'il existe un périphérique de capture multimédia accessible et que vous utilisez le navigateur le plus récent et le plus moderne pour une meilleure expérience.",
        "instructions": "Instruction(s) : %{text}",
        "job_type_options": {
          "contract": "Contrat",
          "fixed_term": "Durée déterminée",
          "full_time": "À plein temps",
          "internship": "Stage",
          "part_time": "À temps partiel",
          "probationary": "Probatoire",
          "project": "Projet",
          "regular": "Ordinaire",
          "seasonal": "Saisonnier",
          "volunteer": "Bénévole"
        },
        "mic_not_permitted": "L'accès au microphone est bloqué.",
        "min_max_char": "Entry should be %{min} character(s) minimum and %{max} characters maximum",
        "no_camera": "Aucune caméra disponible.",
        "no_media_device": "Aucun périphérique multimédia accessible.",
        "no_mic": "Aucun micro disponible.",
        "no_supported_mimetype": "Il n'y a pas de type de support MIME pris en charge dans ce navigateur et la qualité d'enregistrement peut en souffrir. Essayez de passer à un autre navigateur ou appareil.",
        "our_social_media": "Nos médias sociaux",
        "privacy_policy": "J'accepte la <a target=\"_b\" href=\"%{policy_url}\">politique de confidentialité</a> de %{company} et la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">politique de confidentialité</a> du fournisseur de services.",
        "privacy_policy_talkpush": "J'accepte la <a target=\"_b\" href=\"https://talkpush.com/privacy/\">politique de confidentialité</a> du fournisseur de services.",
        "privacy_policy_url": "https://talkpush.com/privacy-applicant/",
        "question_progress": "%{current} sur %{size}",
        "rate_your_experience": "Évaluez votre expérience",
        "receive_updates": "Je souhaite recevoir des mises à jour par SMS, Facebook, Messenger ou WhatsApp.",
        "remote_types": {
          "fully_remote": "Entièrement en télétravail",
          "temporarily_remote": "Temporairement en télétravail",
          "wfh_flexible": "Télétravail flexible"
        },
        "salary_types": {
          "annually": "Annuellement",
          "biweekly": "Bihebdomadaire",
          "daily": "tous les jours",
          "hourly": "Hourly",
          "monthly": "Mensuel",
          "one-time": "Une fois",
          "weekly": "hebdomadaire"
        },
        "share_with_network": "Share with your network",
        "size_of_mb": "%{size} de 20 Mo",
        "thank_you": "Merci",
        "trouble_playing_response": "Tu as du mal à lire cette réponse?",
        "upload": {
          "error": "Certains fichiers ne peuvent pas être téléchargés.",
          "file_invalid_type": "Le format de fichier doit être .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "La taille du fichier doit être inférieure à 10 Mo."
        },
        "upload_failed": "There was an error while uploading your response. Please try again.",
        "video_limit": "La durée de réponse vidéo maximale est de 1 minute."
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "E-mail",
        "first_name": "Prénom",
        "last_name": "Nom de famille",
        "new_recording": "Nouvel enregistrement",
        "phone_number": "Numéro de téléphone",
        "record_now": "Enregistrer maintenant",
        "start_camera": "Démarrer la caméra",
        "stop_recording": "Arrêter d'enregistrer",
        "take_picture": "Prendre une photo"
      },
      "notes": {
        "video_limit": "La durée de réponse vidéo maximale est de 1 minute."
      },
      "show": {
        "about": "Au sujet de"
      },
      "success": {
        "answers_message": "Vos réponses ont été soumises avec succès.",
        "title": "Merci"
      }
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Ajouter une image",
      "apply": "Postuler",
      "change_image": "Changer l'image",
      "copy": "Copier",
      "save": "Enregistrer",
      "select_page_helper": "Lier des pages Facebook signifie que toute personne qui discute avec votre bot peut voir cette campagne. Pour que cette campagne n'apparaisse pas sur le chatbot, laissez ce champ vide. Ci-dessous, vous pouvez voir tous les liens d'entretien de Messenger pour diriger directement les candidats vers l'entretien chatbot, cela est disponible même si la page Facebook n'est pas liée à cette campagne (indiquée par l'icône de verrouillage).",
      "view_job_description": "Voir la description du poste"
    },
    "google": {
      "google_job": "Emplois Google (bêta)",
      "job_par": {
        "best_practice": "les meilleures pratiques",
        "first": "Les emplois répertoriés sur Google apparaîtront directement dans les résultats de recherche Google.",
        "head": "Activer l'indexation Google de la page de destination.",
        "help_center": "notre centre d'aide",
        "second": "Les candidats qui cliquent sur ces listes d'emplois sont redirigés vers la page d'accueil des offres d'emplois Talkpush, où ils peuvent choisir de postuler et de répondre immédiatement aux questions de sélection. Vous pouvez en savoir plus à ce sujet dans",
        "third": "Si votre emploi n'apparaît pas dans les offres d'emploi publiées de Google, assurez-vous de suivre ces"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Le titre du poste, le pays, la région et une longue description sont requis. "
      }
    },
    "landing": {
      "copy": "Copier",
      "first": "URL de la page de destination",
      "save": "Enregistrer"
    },
    "lead": {
      "associated": "Page Facebook Associée",
      "authorize": "Autoriser l'application Talkpush Lead Ads d'accéder au leads généré par votre page Facebook",
      "failed_duplicate": "Cet identifiant d'annonce principale est déjà utilisé par %{campaign}.",
      "failed_no_fb_page": "Veuillez d'abord associer cette entreprise à une page Facebook.",
      "how_to": "Comment configurer les Lead Ad pour Talkpush",
      "id": "Identifiant Lead Ad",
      "list": "List de publicités Lead-Ads",
      "login": "Se connecter avec Facebook",
      "submit": "Envoyer",
      "success_add": "Lead ajouté avec succès",
      "success_delete": "Lead supprimé avec succès",
      "title": "Annonces de Candidats"
    },
    "spreadsheet": {
      "authorize": "Autoriser l'accès",
      "create_par": "Créer un formulaire Google",
      "erp": "Programme de référence des employés",
      "googlesheet": "Lien URL vers la feuille de calcul Google",
      "here": "ici",
      "ncs": "Candidature normale d'un candidat",
      "paste": "Copier le lien vers votre feuille de calcul Google",
      "please": "Merci d'entrer un lien URL valide connecté à un formulaire Google",
      "step1": "Étape 1",
      "step2": "Étape 2",
      "step2_par": "Créer une feuille de calcul Google contenant les réponses au formulaire Google ci-dessus",
      "step3": "Étape 3",
      "step3_par": "Copier coller le lien URL vers la feuille de calcul Google dans le champ ci-dessous et cliquer sur Autoriser l'accès",
      "step4": "Étape 4",
      "step4_par": "Confirmez vos identifiants de compte Google pour donner à Talkpush l'accès à la feuille de calcul",
      "title": "Feuille de calcul",
      "two_ex": "Voici deux exemples",
      "wiki": "Wiki",
      "wiki_par": "suivre les instructions définies sur"
    },
    "tecoloco": {
      "job_par": {
        "first": "Jobs that are listed in Tecoloco will appear in the Tecoloco feed.",
        "head": "Advertise the job opening on Tecoloco Jobs",
        "help_center": "notre centre d'aide",
        "second": "Candidates who apply to these job listings are forwarded to the Talkpush Job Landing Page, where they can apply and immediately complete the screening questions. You can learn more about it in"
      },
      "tecoloco_jobs": "Tecoloco Jobs"
    }
  },
  "job_landing_page": {
  },
  "jobs": {
    "salary_types": {
      "annually": "Annuellement",
      "biweekly": "Bihebdomadaire",
      "daily": "tous les jours",
      "hourly": "Hourly",
      "monthly": "Mensuel",
      "one-time": "Une fois",
      "weekly": "hebdomadaire"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": " ",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": " ",
      "precision": 3,
      "round_mode": "default",
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "milliard",
          "million": "million",
          "quadrillion": "million de milliards",
          "thousand": "millier",
          "trillion": "billion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "octet",
            "other": "octets"
          },
          "eb": "Eo",
          "gb": "Go",
          "kb": "ko",
          "mb": "Mo",
          "pb": "Po",
          "tb": "To"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%",
        "precision": 1
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy-applicant/",
  "setup_questions": {
    "question_types": {
      "audio": "l'audio",
      "text": "Texte"
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%d %B %Y %Hh %Mmin %Ss",
      "long": "%A %d %B %Y %Hh%M",
      "short": "%d %b %Hh%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "pm": "pm"
  }
});
I18n.translations["in"] = I18n.extend((I18n.translations["in"] || {}), {
  "autoflow": {
    "next": "Next"
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Facebook Job saved successfully"
      },
      "google": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Google Jobs saved successfully"
      },
      "landing_page": {
        "add_url": "Add a URL",
        "cancel": "Cancel",
        "custom_landing_page_description": "Generate new URLs and assign a source name per URL. Candidates who complete pre-screening on the URL will be tracked with your customized source name. Common source names are site name and assigned recruiter name, event name.",
        "custom_landing_page_title": "Customize the Landing Page Source",
        "custom_source_label": "Source Name",
        "date_created": "Date Created",
        "invalid_url": "Invalid Redirect URL",
        "landing_pages": "Landing Pages",
        "landing_pages_desc": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "redirect_after": "Redirect After",
        "redirect_url": "Redirect URL",
        "refresh_rate_min_error": "Refresh Rate must be at least 1 second",
        "reload_redirect": "Redirect/Reload",
        "save_success": "Landing page saved successfully",
        "seconds": "Seconds",
        "source_placeholder": "Ex. Washington Site",
        "source_title": "Track a custom source",
        "url_copy": "URL copied to clipboard"
      },
      "lead_ads": {
        "delete_success": "Lead Ad deleted successfully",
        "save_success": "Lead Ad added successfully"
      },
      "messenger": {
        "copy_url": "Copy URL",
        "create_messenger_source_url": "Create URL",
        "create_messenger_source_url_success": "Messenger URL was created successfully",
        "default_input_source_value": "Source",
        "default_select_option_value": "Select...",
        "facebook_pages": "Facebook Pages",
        "messenger_link": "Messenger Link",
        "messenger_source_url_description": "Leads that use this Messenger URL will be tracked with this source.",
        "messenger_source_url_title": "Track a custom source in Messenger URL",
        "page_title": "Facebook Page",
        "previously_created_messenger_urls": "Previously created Messenger URLs",
        "previously_created_messenger_urls_description": "Here are all the previously created Messenger URLs for this campaign.",
        "select_pages": "Select the Facebook Pages to list this campaign on Messenger, then click Save to apply your changes",
        "source_label": "Source",
        "source_title": "Track a custom source"
      },
      "sms": {
        "apply_number": "Candidates can apply to this job by sending an SMS to this dedicated phone number",
        "text_copied": "Text copied to clipboard",
        "with_format": "with the following format"
      },
      "tecoloco_jobs": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Tecoloco Jobs saved successfully"
      }
    }
  },
  "campaigns": {
    "edit": {
      "form": {
        "job_type": "Job type",
        "job_type_options": {
          "contract": "Contract",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "location": "Location",
        "salary": "Salary"
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Share"
        }
      }
    },
    "buttons": {
      "proceed": "Proceed",
      "submit": "Submit"
    },
    "options": {
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATS APP"
    },
    "upload": "Upload"
  },
  "companies": {
    "settings": {
      "team": {
        "role_permissions": {
          "manager": "Manager"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about 1 hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about 1 month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about 1 year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost 1 year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than 1 second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over 1 year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "1 day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "1 second",
        "other": "less than %{count} seconds"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Seconds",
      "year": "Year"
    }
  },
  "eos": {
    "campaign": {
      "label": {
        "add_button": "Add a Button",
        "banner": "Banner",
        "call_to_action": "Call to Action",
        "cancel": "Cancel",
        "completion_message": "Completion Message",
        "copy": "Copy",
        "create_button": "Create Button",
        "crop": "Crop",
        "facebook_pixel_id": "Facebook Pixel ID",
        "google_tag_container_id": "Google Tag Manager Container ID",
        "landing_page_type": "Landing Page Type",
        "landing_page_url": "Landing Page URL",
        "new_landing_page_design": "New Landing Page design",
        "redirect_url": "Redirect URL",
        "text_displayed": "Text displayed"
      },
      "text": {
        "active_cta_limit": "Active button count limit reached.",
        "add_cta": "Add Call to Action buttons to the Completion Screen",
        "add_cta_info": "Call to Action buttons on Landing Page completion screens to redirect applicants to your socials or to perform an action. You can create multiple buttons, but only three can be active at a time.",
        "allowed_banner_files": "Allowed file types: jpg, png, jpeg. Max 2MB.",
        "apply_new_design": "Apply the new landing page design to this campaign.",
        "banner_notice": "You are using the default banner for all your campaigns from Company Settings.",
        "banner_required": "Banner is required.",
        "button_limit_reached": "Button count hard limit reached",
        "click_on_dropdown": "Click on dropdown to read more about each type.",
        "custom_source_guide": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "default_banner_use": "If no banner is added and a Default Banner is available in Company Settings, the Default Banner will be used.",
        "incomplete_details": "Incomplete details",
        "internal_server_error": "Sorry, we are experiencing an internal server problem. Please try again later.",
        "invalid_url": "%{url} is not a valid URL",
        "landing_page_type": {
          "multiple": {
            "description": "Questions are displayed one screen at a time.",
            "title": "One Question Per Screen"
          },
          "single": {
            "description": "All questions are displayed on a single page.",
            "title": "Long Form"
          }
        },
        "landing_pages": "Landing Pages",
        "nothing_to_update": "Nothing to update.",
        "page_type_notice": "You have already selected a %{type} type for all your campaigns from Company Settings.",
        "recommended_banner": "2100px x 1100px recommended.",
        "shown_end_form": "Shown at the end of the form.",
        "updated_successfully": "Updated successfully."
      }
    },
    "company": {
      "label": {
        "color_theme": "Color theme",
        "default_banner": "Default Banner",
        "primary": "Primary",
        "secondary": "Secondary",
        "shade": "Shade"
      },
      "text": {
        "apply_new_design": "Apply the new landing page design to all campaigns.",
        "apply_page_type": "Apply the Landing Page Type to all Campaigns. If selected, option will be disabled in Campaign Settings.",
        "default_banner": "If no banner is uploaded to a campaign, the Default Banner will be used.",
        "default_banner_use": "Use Default Banner across all campaigns. If selected, option will be disabled in Campaign Settings.",
        "enter_custom_color": "Alternatively, you can enter HEX code values in the Primary and Secondary text fields.",
        "select_color_palette": "Select colors for the Landing Page color theme using the palette and sliders below."
      }
    },
    "landing_page": {
      "communication_channels": {
        "email": "Email",
        "errors": {
          "field_required": "%{field} required."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Besides email, what is the best way to get a hold of you and update you on on the next steps?",
        "whatsapp": "WhatsApp"
      },
      "label": {
        "audio": "Audio",
        "click_download": "Click here to download",
        "contract": "Contract",
        "copy_it": "Copy it",
        "email": "Email",
        "email_it": "Email it",
        "error": "Error",
        "facebook": "Facebook",
        "file_upload": "File Upload",
        "first_name": "First Name",
        "fixed_term": "Fixed Term",
        "full_time": "Full time",
        "get_started": "Get Started",
        "internship": "Internship",
        "job_type": "Job Type",
        "last_name": "Last Name",
        "location": "Location",
        "new_recording": "New Recording",
        "next": "Next",
        "part_time": "Part time",
        "pause": "Pause",
        "phone_number": "Phone Number",
        "picture": "Picture",
        "play": "Play",
        "play_recording": "Play Recording",
        "post_it": "Post it",
        "probationary": "Probationary",
        "proceed": "Proceed",
        "project": "Project",
        "record_now": "Record Now",
        "regular": "Regular",
        "retake_picture": "Retake Picture",
        "retry": "Retry",
        "salary": "Salary",
        "save": "Save",
        "seasonal": "Seasonal",
        "share": "Share",
        "share_it": "Share it",
        "snap_photo": "Snap Photo",
        "start_camera": "Start Camera",
        "start_recording": "Start Recording",
        "stop": "Stop",
        "stop_recording": "Stop Recording",
        "submit": "Submit",
        "take_picture": "Take a picture",
        "text": "Text",
        "tweet_it": "Tweet it",
        "undisclosed": "Undisclosed",
        "upload": "Upload",
        "view_sample": "View Sample",
        "volunteer": "Volunteer",
        "warning": "Warning",
        "whatsapp": "WhatsApp",
        "your_progress": "Your progress"
      },
      "text": {
        "about_company": "About %{company}",
        "about_our_company": "About our company",
        "application_invalid": "Invalid application",
        "camera_not_permitted": "Camera access is blocked.",
        "close_warning": "In case of leaving this questionnaire before its completion, it can be completed on a later attempt, but no previously provided answer/record will be visible or editable.",
        "completion_message": "You have successfully completed and submitted your application for %{job}. Thank you!",
        "contact_channel": "What is the best way to contact me about my application?",
        "copied_succesfully": "Copied successfully",
        "generic_browser_error": "Unable to record media. Make sure that there is an accessible media capture device and you are using the latest and modern browser for best experience.",
        "instructions": "Instruction(s): %{text}",
        "job_type_options": {
          "contract": "Contract",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "mic_not_permitted": "Microphone access is blocked.",
        "min_max_char": "Entry should be %{min} character(s) minimum and %{max} characters maximum",
        "no_camera": "No camera available.",
        "no_media_device": "No accessible media device.",
        "no_mic": "No microphone available.",
        "no_supported_mimetype": "There are no supported MIME media type in this browser and recording quality might suffer. Try switching to another browser or device.",
        "our_social_media": "Our Social Media",
        "privacy_policy": "I agree to the <a target=\"_b\" href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_talkpush": "I agree to the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_url": "https://talkpush.com/privacy/",
        "question_progress": "%{current} of %{size}",
        "rate_your_experience": "Rate your experience",
        "receive_updates": "I want to receive updates through SMS, Facebook, Messenger or Whatsapp.",
        "remote_types": {
          "fully_remote": "Fully Remote",
          "temporarily_remote": "Temporarily Remote",
          "wfh_flexible": "WFH Flexible"
        },
        "salary_types": {
          "annually": "Annually",
          "biweekly": "Biweekly",
          "daily": "Daily",
          "hourly": "Hourly",
          "monthly": "Monthly",
          "one-time": "One-time",
          "weekly": "Weekly"
        },
        "share_with_network": "Share with your network",
        "size_of_mb": "%{size} of 20mb",
        "thank_you": "Thank you",
        "trouble_playing_response": "Having trouble playing this response?",
        "upload": {
          "error": "Some files cannot be uploaded.",
          "file_invalid_type": "File format should be .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "The file size should be less than 10MB."
        },
        "upload_failed": "There was an error while uploading your response. Please try again.",
        "video_limit": "The maximum video response length is 1 minute."
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "new_recording": "New Recording",
        "phone_number": "Phone Number",
        "record_now": "Record Now",
        "start_camera": "Start Camera",
        "stop_recording": "Stop Recording",
        "take_picture": "Take a picture"
      },
      "notes": {
        "video_limit": "The maximum video response length is 1 minute."
      },
      "show": {
        "about": "About"
      },
      "success": {
        "answers_message": "Thank you for submitting your responses. We have received your application.",
        "title": "Thank you"
      }
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Add Image",
      "apply": "Apply",
      "change_image": "Change Image",
      "copy": "Copy",
      "save": "Save",
      "select_page_helper": "Linking Facebook page(s) means anyone who chats to your bot can see this campaign. For this campaign not to appear on the chatbot, leave this field empty.\nBelow you can see all the messenger interview links to direct candidates directly to the chatbot interview, this is available even if the facebook page is not linked to this campaign (indicated by the lock icon).",
      "view_job_description": "View Job Description"
    },
    "google": {
      "google_job": "Google Jobs (beta)",
      "job_par": {
        "best_practice": "best_practices",
        "first": "Jobs that are listed on Google will appear directly in the Google search results.",
        "head": "Enable Google indexing of the Landing Page",
        "help_center": "our help center",
        "second": "Applicants that click on these job listings are forwarded to the Talkpush Job Landing Page, where they can choose to apply and immediately complete the screening questions. You can learn more about it in",
        "third": "If your job does not appear in the Google Job posting please make sure you are following those"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Requires job title, country, region, and long description to be filled out."
      }
    },
    "landing": {
      "copy": "Copy",
      "first": "Landing Page URL",
      "save": "Save"
    },
    "lead": {
      "associated": "Associated facebook page",
      "authorize": "You need to associate your facebook page to our facebook app (Talkpush Bot) to process generated leads",
      "failed_duplicate": "This Lead Ad ID is already being used by %{campaign}",
      "failed_no_fb_page": "Please associate this company to a facebook page first",
      "how_to": "How to Setup lead ad for Talkpush",
      "id": "Lead Ad ID",
      "list": "List of Lead Ads ID",
      "login": "Login with Facebook",
      "submit": "Submit",
      "success_add": "Lead successfully added",
      "success_delete": "Lead successfully deleted",
      "title": "Lead Ads"
    },
    "spreadsheet": {
      "authorize": "Authorize Access",
      "create_par": "Create a Google form",
      "erp": "Employee Referral Program",
      "googlesheet": "Google spreadsheet URL",
      "here": "here",
      "ncs": "Normal Candidate Submission",
      "paste": "Paste your google spreadsheet‚Äôs link here.",
      "please": "Please input a valid Google Spreadsheet URL which is connected to your Google Form",
      "step1": "Step 1",
      "step2": "Step 2",
      "step2_par": "Create a Google Spreadsheet containing the responses of the Google Form above",
      "step3": "Step 3",
      "step3_par": "Copy paste the Google Spreadsheet's URL to the field below and Click on Authorize Access",
      "step4": "Step 4",
      "step4_par": "Confirm your Google Account credentials to provide Talkpush with access to the Spreadsheet",
      "title": "Spreadsheet",
      "two_ex": "Here are two examples",
      "wiki": "Wiki",
      "wiki_par": "following instructions outlined on our"
    },
    "tecoloco": {
      "job_par": {
        "first": "Jobs that are listed in Tecoloco will appear in the Tecoloco feed.",
        "head": "Advertise the job opening on Tecoloco Jobs",
        "help_center": "our help center",
        "second": "Candidates who apply to these job listings are forwarded to the Talkpush Job Landing Page, where they can apply and immediately complete the screening questions. You can learn more about it in"
      },
      "tecoloco_jobs": "Tecoloco Jobs"
    }
  },
  "job_landing_page": {
    "application_invalid": "Invalid application"
  },
  "jobs": {
    "salary_types": {
      "annually": "Annually",
      "biweekly": "Biweekly",
      "daily": "Daily",
      "hourly": "Hourly",
      "monthly": "Monthly",
      "one-time": "One-time",
      "weekly": "Weekly"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy/",
  "setup_questions": {
    "question_types": {
      "audio": "Audio",
      "text": "Text"
    }
  },
  "time": {
    "am": "AM",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "pm": "PM"
  }
});
I18n.translations["zh"] = I18n.extend((I18n.translations["zh"] || {}), {
  "autoflow": {
    "next": "Next"
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Facebook Job saved successfully"
      },
      "google": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Google Jobs saved successfully"
      },
      "landing_page": {
        "add_url": "Add a URL",
        "cancel": "Cancel",
        "custom_landing_page_description": "Generate new URLs and assign a source name per URL. Candidates who complete pre-screening on the URL will be tracked with your customized source name. Common source names are site name and assigned recruiter name, event name.",
        "custom_landing_page_title": "Customize the Landing Page Source",
        "custom_source_label": "Source Name",
        "date_created": "Date Created",
        "invalid_url": "Invalid Redirect URL",
        "landing_pages": "Landing Pages",
        "landing_pages_desc": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "redirect_after": "Redirect After",
        "redirect_url": "Redirect URL",
        "refresh_rate_min_error": "Refresh Rate must be at least 1 second",
        "reload_redirect": "Redirect/Reload",
        "save_success": "Landing page saved successfully",
        "seconds": "Seconds",
        "source_placeholder": "Ex. Washington Site",
        "source_title": "Track a custom source",
        "url_copy": "URL copied to clipboard"
      },
      "lead_ads": {
        "delete_success": "Lead Ad deleted successfully",
        "save_success": "Lead Ad added successfully"
      },
      "messenger": {
        "copy_url": "Copy URL",
        "create_messenger_source_url": "Create URL",
        "create_messenger_source_url_success": "Messenger URL was created successfully",
        "default_input_source_value": "Source",
        "default_select_option_value": "Select...",
        "facebook_pages": "Facebook Pages",
        "messenger_link": "Messenger Link",
        "messenger_source_url_description": "Leads that use this Messenger URL will be tracked with this source.",
        "messenger_source_url_title": "Track a custom source in Messenger URL",
        "page_title": "Facebook Page",
        "previously_created_messenger_urls": "Previously created Messenger URLs",
        "previously_created_messenger_urls_description": "Here are all the previously created Messenger URLs for this campaign.",
        "select_pages": "Select the Facebook Pages to list this campaign on Messenger, then click Save to apply your changes",
        "source_label": "Source",
        "source_title": "Track a custom source"
      },
      "sms": {
        "apply_number": "Candidates can apply to this job by sending an SMS to this dedicated phone number",
        "text_copied": "Text copied to clipboard",
        "with_format": "with the following format"
      },
      "tecoloco_jobs": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Tecoloco Jobs saved successfully"
      }
    }
  },
  "campaigns": {
    "edit": {
      "form": {
        "job_type": "Job type",
        "job_type_options": {
          "contract": "Contract",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "location": "Location",
        "salary": "Salary"
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Share"
        }
      }
    },
    "buttons": {
      "proceed": "Proceed",
      "submit": "Submit"
    },
    "options": {
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATS APP"
    },
    "upload": "Upload"
  },
  "companies": {
    "settings": {
      "team": {
        "role_permissions": {
          "manager": "Manager"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about 1 hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about 1 month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about 1 year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost 1 year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than 1 second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over 1 year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "1 day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "1 second",
        "other": "less than %{count} seconds"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Seconds",
      "year": "Year"
    }
  },
  "eos": {
    "campaign": {
      "label": {
        "add_button": "Add a Button",
        "banner": "Banner",
        "call_to_action": "Call to Action",
        "cancel": "Cancel",
        "completion_message": "Completion Message",
        "copy": "Copy",
        "create_button": "Create Button",
        "crop": "Crop",
        "facebook_pixel_id": "Facebook Pixel ID",
        "google_tag_container_id": "Google Tag Manager Container ID",
        "landing_page_type": "Landing Page Type",
        "landing_page_url": "Landing Page URL",
        "new_landing_page_design": "New Landing Page design",
        "redirect_url": "Redirect URL",
        "text_displayed": "Text displayed"
      },
      "text": {
        "active_cta_limit": "Active button count limit reached.",
        "add_cta": "Add Call to Action buttons to the Completion Screen",
        "add_cta_info": "Call to Action buttons on Landing Page completion screens to redirect applicants to your socials or to perform an action. You can create multiple buttons, but only three can be active at a time.",
        "allowed_banner_files": "Allowed file types: jpg, png, jpeg. Max 2MB.",
        "apply_new_design": "Apply the new landing page design to this campaign.",
        "banner_notice": "You are using the default banner for all your campaigns from Company Settings.",
        "banner_required": "Banner is required.",
        "button_limit_reached": "Button count hard limit reached",
        "click_on_dropdown": "Click on dropdown to read more about each type.",
        "custom_source_guide": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "default_banner_use": "If no banner is added and a Default Banner is available in Company Settings, the Default Banner will be used.",
        "incomplete_details": "Incomplete details",
        "internal_server_error": "Sorry, we are experiencing an internal server problem. Please try again later.",
        "invalid_url": "%{url} is not a valid URL",
        "landing_page_type": {
          "multiple": {
            "description": "Questions are displayed one screen at a time.",
            "title": "One Question Per Screen"
          },
          "single": {
            "description": "All questions are displayed on a single page.",
            "title": "Long Form"
          }
        },
        "landing_pages": "Landing Pages",
        "nothing_to_update": "Nothing to update.",
        "page_type_notice": "You have already selected a %{type} type for all your campaigns from Company Settings.",
        "recommended_banner": "2100px x 1100px recommended.",
        "shown_end_form": "Shown at the end of the form.",
        "updated_successfully": "Updated successfully."
      }
    },
    "company": {
      "label": {
        "color_theme": "Color theme",
        "default_banner": "Default Banner",
        "primary": "Primary",
        "secondary": "Secondary",
        "shade": "Shade"
      },
      "text": {
        "apply_new_design": "Apply the new landing page design to all campaigns.",
        "apply_page_type": "Apply the Landing Page Type to all Campaigns. If selected, option will be disabled in Campaign Settings.",
        "default_banner": "If no banner is uploaded to a campaign, the Default Banner will be used.",
        "default_banner_use": "Use Default Banner across all campaigns. If selected, option will be disabled in Campaign Settings.",
        "enter_custom_color": "Alternatively, you can enter HEX code values in the Primary and Secondary text fields.",
        "select_color_palette": "Select colors for the Landing Page color theme using the palette and sliders below."
      }
    },
    "landing_page": {
      "communication_channels": {
        "email": "Email",
        "errors": {
          "field_required": "%{field} required."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Besides email, what is the best way to get a hold of you and update you on on the next steps?",
        "whatsapp": "WhatsApp"
      },
      "label": {
        "audio": "Audio",
        "click_download": "Click here to download",
        "contract": "Contract",
        "copy_it": "Copy it",
        "email": "Email",
        "email_it": "Email it",
        "error": "Error",
        "facebook": "Facebook",
        "file_upload": "File Upload",
        "first_name": "First Name",
        "fixed_term": "Fixed Term",
        "full_time": "Full time",
        "get_started": "Get Started",
        "internship": "Internship",
        "job_type": "Job Type",
        "last_name": "Last Name",
        "location": "Location",
        "new_recording": "New Recording",
        "next": "Next",
        "part_time": "Part time",
        "pause": "Pause",
        "phone_number": "Phone Number",
        "picture": "Picture",
        "play": "Play",
        "play_recording": "Play Recording",
        "post_it": "Post it",
        "probationary": "Probationary",
        "proceed": "Proceed",
        "project": "Project",
        "record_now": "Record Now",
        "regular": "Regular",
        "retake_picture": "Retake Picture",
        "retry": "Retry",
        "salary": "Salary",
        "save": "Save",
        "seasonal": "Seasonal",
        "share": "Share",
        "share_it": "Share it",
        "snap_photo": "Snap Photo",
        "start_camera": "Start Camera",
        "start_recording": "Start Recording",
        "stop": "Stop",
        "stop_recording": "Stop Recording",
        "submit": "Submit",
        "take_picture": "Take a picture",
        "text": "Text",
        "tweet_it": "Tweet it",
        "undisclosed": "Undisclosed",
        "upload": "Upload",
        "view_sample": "View Sample",
        "volunteer": "Volunteer",
        "warning": "Warning",
        "whatsapp": "WhatsApp",
        "your_progress": "Your progress"
      },
      "text": {
        "about_company": "About %{company}",
        "about_our_company": "About our company",
        "application_invalid": "Invalid application",
        "camera_not_permitted": "Camera access is blocked.",
        "close_warning": "In case of leaving this questionnaire before its completion, it can be completed on a later attempt, but no previously provided answer/record will be visible or editable.",
        "completion_message": "You have successfully completed and submitted your application for %{job}. Thank you!",
        "contact_channel": "What is the best way to contact me about my application?",
        "copied_succesfully": "Copied successfully",
        "generic_browser_error": "Unable to record media. Make sure that there is an accessible media capture device and you are using the latest and modern browser for best experience.",
        "instructions": "Instruction(s): %{text}",
        "job_type_options": {
          "contract": "Contract",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "mic_not_permitted": "Microphone access is blocked.",
        "min_max_char": "Entry should be %{min} character(s) minimum and %{max} characters maximum",
        "no_camera": "No camera available.",
        "no_media_device": "No accessible media device.",
        "no_mic": "No microphone available.",
        "no_supported_mimetype": "There are no supported MIME media type in this browser and recording quality might suffer. Try switching to another browser or device.",
        "our_social_media": "Our Social Media",
        "privacy_policy": "I agree to the <a target=\"_b\" href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_talkpush": "I agree to the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_url": "https://talkpush.com/privacy/",
        "question_progress": "%{current} of %{size}",
        "rate_your_experience": "Rate your experience",
        "receive_updates": "I want to receive updates through SMS, Facebook, Messenger or Whatsapp.",
        "remote_types": {
          "fully_remote": "Fully Remote",
          "temporarily_remote": "Temporarily Remote",
          "wfh_flexible": "WFH Flexible"
        },
        "salary_types": {
          "annually": "Annually",
          "biweekly": "Biweekly",
          "daily": "Daily",
          "hourly": "Hourly",
          "monthly": "Monthly",
          "one-time": "One-time",
          "weekly": "Weekly"
        },
        "share_with_network": "Share with your network",
        "size_of_mb": "%{size} of 20mb",
        "thank_you": "Thank you",
        "trouble_playing_response": "Having trouble playing this response?",
        "upload": {
          "error": "Some files cannot be uploaded.",
          "file_invalid_type": "File format should be .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "The file size should be less than 10MB."
        },
        "upload_failed": "There was an error while uploading your response. Please try again.",
        "video_limit": "The maximum video response length is 1 minute."
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "new_recording": "New Recording",
        "phone_number": "Phone Number",
        "record_now": "Record Now",
        "start_camera": "Start Camera",
        "stop_recording": "Stop Recording",
        "take_picture": "Take a picture"
      },
      "notes": {
        "video_limit": "The maximum video response length is 1 minute."
      },
      "show": {
        "about": "About"
      },
      "success": {
        "answers_message": "Thank you for submitting your responses. We have received your application.",
        "title": "Thank you"
      }
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Add Image",
      "apply": "Apply",
      "change_image": "Change Image",
      "copy": "Copy",
      "save": "Save",
      "select_page_helper": "Linking Facebook page(s) means anyone who chats to your bot can see this campaign. For this campaign not to appear on the chatbot, leave this field empty.\nBelow you can see all the messenger interview links to direct candidates directly to the chatbot interview, this is available even if the facebook page is not linked to this campaign (indicated by the lock icon).",
      "view_job_description": "View Job Description"
    },
    "google": {
      "google_job": "Google Jobs (beta)",
      "job_par": {
        "best_practice": "best_practices",
        "first": "Jobs that are listed on Google will appear directly in the Google search results.",
        "head": "Enable Google indexing of the Landing Page",
        "help_center": "our help center",
        "second": "Applicants that click on these job listings are forwarded to the Talkpush Job Landing Page, where they can choose to apply and immediately complete the screening questions. You can learn more about it in",
        "third": "If your job does not appear in the Google Job posting please make sure you are following those"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Requires job title, country, region, and long description to be filled out."
      }
    },
    "landing": {
      "copy": "Copy",
      "first": "Landing Page URL",
      "save": "Save"
    },
    "lead": {
      "associated": "Associated facebook page",
      "authorize": "You need to associate your facebook page to our facebook app (Talkpush Bot) to process generated leads",
      "failed_duplicate": "This Lead Ad ID is already being used by %{campaign}",
      "failed_no_fb_page": "Please associate this company to a facebook page first",
      "how_to": "How to Setup lead ad for Talkpush",
      "id": "Lead Ad ID",
      "list": "List of Lead Ads ID",
      "login": "Login with Facebook",
      "submit": "Submit",
      "success_add": "Lead successfully added",
      "success_delete": "Lead successfully deleted",
      "title": "Lead Ads"
    },
    "spreadsheet": {
      "authorize": "Authorize Access",
      "create_par": "Create a Google form",
      "erp": "Employee Referral Program",
      "googlesheet": "Google spreadsheet URL",
      "here": "here",
      "ncs": "Normal Candidate Submission",
      "paste": "Paste your google spreadsheet‚Äôs link here.",
      "please": "Please input a valid Google Spreadsheet URL which is connected to your Google Form",
      "step1": "Step 1",
      "step2": "Step 2",
      "step2_par": "Create a Google Spreadsheet containing the responses of the Google Form above",
      "step3": "Step 3",
      "step3_par": "Copy paste the Google Spreadsheet's URL to the field below and Click on Authorize Access",
      "step4": "Step 4",
      "step4_par": "Confirm your Google Account credentials to provide Talkpush with access to the Spreadsheet",
      "title": "Spreadsheet",
      "two_ex": "Here are two examples",
      "wiki": "Wiki",
      "wiki_par": "following instructions outlined on our"
    },
    "tecoloco": {
      "job_par": {
        "first": "Jobs that are listed in Tecoloco will appear in the Tecoloco feed.",
        "head": "Advertise the job opening on Tecoloco Jobs",
        "help_center": "our help center",
        "second": "Candidates who apply to these job listings are forwarded to the Talkpush Job Landing Page, where they can apply and immediately complete the screening questions. You can learn more about it in"
      },
      "tecoloco_jobs": "Tecoloco Jobs"
    }
  },
  "job_landing_page": {
    "application_invalid": "Invalid application"
  },
  "jobs": {
    "salary_types": {
      "annually": "Annually",
      "biweekly": "Biweekly",
      "daily": "Daily",
      "hourly": "Hourly",
      "monthly": "Monthly",
      "one-time": "One-time",
      "weekly": "Weekly"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy/",
  "setup_questions": {
    "question_types": {
      "audio": "Audio",
      "text": "Text"
    }
  },
  "time": {
    "am": "AM",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "pm": "PM"
  }
});
I18n.translations["zh-HK"] = I18n.extend((I18n.translations["zh-HK"] || {}), {
  "autoflow": {
    "next": "下一步"
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Facebook Job saved successfully"
      },
      "google": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Google Jobs saved successfully"
      },
      "landing_page": {
        "add_url": "Add a URL",
        "cancel": "取消",
        "custom_landing_page_description": "Generate new URLs and assign a source name per URL. Candidates who complete pre-screening on the URL will be tracked with your customized source name. Common source names are site name and assigned recruiter name, event name.",
        "custom_landing_page_title": "Customize the Landing Page Source",
        "custom_source_label": "Source Name",
        "date_created": "Date Created",
        "invalid_url": "Invalid Redirect URL",
        "landing_pages": "Landing Pages",
        "landing_pages_desc": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "redirect_after": "Redirect After",
        "redirect_url": "Redirect URL",
        "refresh_rate_min_error": "Refresh Rate must be at least 1 second",
        "reload_redirect": "Redirect/Reload",
        "save_success": "Landing page saved successfully",
        "seconds": "秒",
        "source_placeholder": "Ex. Washington Site",
        "source_title": "Track a custom source",
        "url_copy": "URL copied to clipboard"
      },
      "lead_ads": {
        "delete_success": "Lead Ad deleted successfully",
        "save_success": "Lead Ad added successfully"
      },
      "messenger": {
        "copy_url": "複製URL",
        "create_messenger_source_url": "Create URL",
        "create_messenger_source_url_success": "Messenger URL was created successfully",
        "default_input_source_value": "來源",
        "default_select_option_value": "Select...",
        "facebook_pages": "Facebook專頁",
        "messenger_link": "即時通訊連結",
        "messenger_source_url_description": "Leads that use this Messenger URL will be tracked with this source.",
        "messenger_source_url_title": "Track a custom source in Messenger URL",
        "page_title": "Facebook專頁",
        "previously_created_messenger_urls": "Previously created Messenger URLs",
        "previously_created_messenger_urls_description": "Here are all the previously created Messenger URLs for this campaign.",
        "select_pages": "選擇Facebook專頁以於即時通訊列出此職位空缺",
        "source_label": "來源",
        "source_title": "Track a custom source"
      },
      "sms": {
        "apply_number": "Candidates can apply to this job by sending an SMS to this dedicated phone number",
        "text_copied": "Text copied to clipboard",
        "with_format": "with the following format"
      },
      "tecoloco_jobs": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Tecoloco Jobs saved successfully"
      }
    }
  },
  "campaigns": {
    "edit": {
      "form": {
        "job_type": "工作類型",
        "job_type_options": {
          "contract": "合約",
          "fixed_term": "Fixed Term",
          "full_time": "全職",
          "internship": "實習",
          "part_time": "兼職",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "義工"
        },
        "location": "地點",
        "salary": "薪酬"
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "分享"
        }
      }
    },
    "buttons": {
      "proceed": "申請此工作",
      "submit": "提交"
    },
    "options": {
      "email": "電郵",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATSAPP"
    },
    "upload": "上載"
  },
  "companies": {
    "settings": {
      "team": {
        "role_permissions": {
          "manager": "經理"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六"
    ],
    "abbr_month_names": [
      null,
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "12月"
    ],
    "day_names": [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%Y-%m-%d",
      "long": "%Y年%m月%d日",
      "short": "%m月%d日"
    },
    "month_names": [
      null,
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "約一小時",
        "other": "約%{count}小時"
      },
      "about_x_months": {
        "one": "約一個月",
        "other": "約%{count}個月"
      },
      "about_x_years": {
        "one": "約一年",
        "other": "約%{count}年"
      },
      "almost_x_years": {
        "one": "接近一年",
        "other": "接近%{count}年"
      },
      "half_a_minute": "半分鐘",
      "less_than_x_minutes": {
        "one": "不到一分鐘",
        "other": "不到%{count}分鐘"
      },
      "less_than_x_seconds": {
        "one": "不到一秒",
        "other": "不到%{count}秒"
      },
      "over_x_years": {
        "one": "超過一年",
        "other": "超過%{count}年"
      },
      "x_days": {
        "one": "一天",
        "other": "%{count}天"
      },
      "x_minutes": {
        "one": "一分鐘",
        "other": "%{count}分鐘"
      },
      "x_months": {
        "one": "一個月",
        "other": "%{count}個月"
      },
      "x_seconds": {
        "one": "一秒",
        "other": "%{count}秒"
      }
    },
    "prompts": {
      "day": "日",
      "hour": "時",
      "minute": "分",
      "month": "月",
      "second": "秒",
      "year": "年"
    }
  },
  "eos": {
    "campaign": {
      "label": {
        "add_button": "Add a Button",
        "banner": "Banner",
        "call_to_action": "Call to Action",
        "cancel": "取消",
        "completion_message": "Completion Message",
        "copy": "複製",
        "create_button": "Create Button",
        "crop": "Crop",
        "facebook_pixel_id": "Facebook Pixel ID",
        "google_tag_container_id": "Google Tag Manager Container ID",
        "landing_page_type": "Landing Page Type",
        "landing_page_url": "登陸頁面網址",
        "new_landing_page_design": "New Landing Page design",
        "redirect_url": "Redirect URL",
        "text_displayed": "Text displayed"
      },
      "text": {
        "active_cta_limit": "Active button count limit reached.",
        "add_cta": "Add Call to Action buttons to the Completion Screen",
        "add_cta_info": "Call to Action buttons on Landing Page completion screens to redirect applicants to your socials or to perform an action. You can create multiple buttons, but only three can be active at a time.",
        "allowed_banner_files": "Allowed file types: jpg, png, jpeg. Max 2MB.",
        "apply_new_design": "Apply the new landing page design to this campaign.",
        "banner_notice": "You are using the default banner for all your campaigns from Company Settings.",
        "banner_required": "Banner is required.",
        "button_limit_reached": "Button count hard limit reached",
        "click_on_dropdown": "Click on dropdown to read more about each type.",
        "custom_source_guide": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "default_banner_use": "If no banner is added and a Default Banner is available in Company Settings, the Default Banner will be used.",
        "incomplete_details": "Incomplete details",
        "internal_server_error": "Sorry, we are experiencing an internal server problem. Please try again later.",
        "invalid_url": "%{url} is not a valid URL",
        "landing_page_type": {
          "multiple": {
            "description": "Questions are displayed one screen at a time.",
            "title": "One Question Per Screen"
          },
          "single": {
            "description": "All questions are displayed on a single page.",
            "title": "Long Form"
          }
        },
        "landing_pages": "Landing Pages",
        "nothing_to_update": "Nothing to update.",
        "page_type_notice": "You have already selected a %{type} type for all your campaigns from Company Settings.",
        "recommended_banner": "2100px x 1100px recommended.",
        "shown_end_form": "Shown at the end of the form.",
        "updated_successfully": "Updated successfully."
      }
    },
    "company": {
      "label": {
        "color_theme": "Color theme",
        "default_banner": "Default Banner",
        "primary": "Primary",
        "secondary": "Secondary",
        "shade": "Shade"
      },
      "text": {
        "apply_new_design": "Apply the new landing page design to all campaigns.",
        "apply_page_type": "Apply the Landing Page Type to all Campaigns. If selected, option will be disabled in Campaign Settings.",
        "default_banner": "If no banner is uploaded to a campaign, the Default Banner will be used.",
        "default_banner_use": "Use Default Banner across all campaigns. If selected, option will be disabled in Campaign Settings.",
        "enter_custom_color": "Alternatively, you can enter HEX code values in the Primary and Secondary text fields.",
        "select_color_palette": "Select colors for the Landing Page color theme using the palette and sliders below."
      }
    },
    "landing_page": {
      "communication_channels": {
        "email": "電郵",
        "errors": {
          "field_required": "%{field} required."
        },
        "messenger": "即時通訊",
        "sms": "短信",
        "text": "Besides email, what is the best way to get a hold of you and update you on on the next steps?",
        "whatsapp": "WhatsApp"
      },
      "label": {
        "audio": "錄音",
        "click_download": "Click here to download",
        "contract": "合約",
        "copy_it": "Copy it",
        "email": "電郵",
        "email_it": "Email it",
        "error": "Error",
        "facebook": "Facebook",
        "file_upload": "File Upload",
        "first_name": "名字",
        "fixed_term": "Fixed Term",
        "full_time": "全職",
        "get_started": "開始",
        "internship": "實習",
        "job_type": "Job Type",
        "last_name": "姓氏",
        "location": "地點",
        "new_recording": "新錄音",
        "next": "下一步",
        "part_time": "兼職",
        "pause": "暫停",
        "phone_number": "電話號碼",
        "picture": "圖片",
        "play": "播放",
        "play_recording": "Play Recording",
        "post_it": "Post it",
        "probationary": "Probationary",
        "proceed": "申請此工作",
        "project": "Project",
        "record_now": "立即錄音",
        "regular": "Regular",
        "retake_picture": "重拍圖片",
        "retry": "Retry",
        "salary": "薪酬",
        "save": "儲存",
        "seasonal": "Seasonal",
        "share": "分享",
        "share_it": "Share it",
        "snap_photo": "拍照",
        "start_camera": "啟動相機",
        "start_recording": "Start Recording",
        "stop": "Stop",
        "stop_recording": "停止錄音",
        "submit": "提交",
        "take_picture": "拍照",
        "text": "短篇文字",
        "tweet_it": "Tweet it",
        "undisclosed": "Undisclosed",
        "upload": "上載",
        "view_sample": "View Sample",
        "volunteer": "義工",
        "warning": "Warning",
        "whatsapp": "WhatsApp",
        "your_progress": "Your progress"
      },
      "text": {
        "about_company": "About %{company}",
        "about_our_company": "About our company",
        "application_invalid": "Invalid application",
        "camera_not_permitted": "Camera access is blocked.",
        "close_warning": "In case of leaving this questionnaire before its completion, it can be completed on a later attempt, but no previously provided answer/record will be visible or editable.",
        "completion_message": "You have successfully completed and submitted your application for %{job}. Thank you!",
        "contact_channel": "What is the best way to contact me about my application?",
        "copied_succesfully": "Copied successfully",
        "generic_browser_error": "Unable to record media. Make sure that there is an accessible media capture device and you are using the latest and modern browser for best experience.",
        "instructions": "Instruction(s): %{text}",
        "job_type_options": {
          "contract": "合約",
          "fixed_term": "Fixed Term",
          "full_time": "全職",
          "internship": "實習",
          "part_time": "兼職",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "義工"
        },
        "mic_not_permitted": "Microphone access is blocked.",
        "min_max_char": "Entry should be %{min} character(s) minimum and %{max} characters maximum",
        "no_camera": "No camera available.",
        "no_media_device": "No accessible media device.",
        "no_mic": "No microphone available.",
        "no_supported_mimetype": "There are no supported MIME media type in this browser and recording quality might suffer. Try switching to another browser or device.",
        "our_social_media": "Our Social Media",
        "privacy_policy": "I agree to the <a target=\"_b\" href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_talkpush": "I agree to the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_url": "https://talkpush.com/privacy/",
        "question_progress": "%{current} of %{size}",
        "rate_your_experience": "Rate your experience",
        "receive_updates": "I want to receive updates through SMS, Facebook, Messenger or Whatsapp.",
        "remote_types": {
          "fully_remote": "Fully Remote",
          "temporarily_remote": "Temporarily Remote",
          "wfh_flexible": "WFH Flexible"
        },
        "salary_types": {
          "annually": "Annually",
          "biweekly": "Biweekly",
          "daily": "Daily",
          "hourly": "Hourly",
          "monthly": "Monthly",
          "one-time": "One-time",
          "weekly": "Weekly"
        },
        "share_with_network": "Share with your network",
        "size_of_mb": "%{size} of 20mb",
        "thank_you": "Thank you",
        "trouble_playing_response": "Having trouble playing this response?",
        "upload": {
          "error": "Some files cannot be uploaded.",
          "file_invalid_type": "File format should be .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "The file size should be less than 10MB."
        },
        "upload_failed": "There was an error while uploading your response. Please try again.",
        "video_limit": "錄影回應最長為2分鐘。"
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "電郵",
        "first_name": "名字",
        "last_name": "姓氏",
        "new_recording": "新錄音",
        "phone_number": "電話號碼",
        "record_now": "立即錄音",
        "start_camera": "啟動相機",
        "stop_recording": "停止錄音",
        "take_picture": "拍照"
      },
      "notes": {
        "video_limit": "錄影回應最長為2分鐘。"
      },
      "show": {
        "about": "關於"
      },
      "success": {
        "answers_message": "Thank you for submitting your responses. We have received your application.",
        "title": "Thank you"
      }
    }
  },
  "integration": {
    "facebook": {
      "add_image": "添加圖片",
      "apply": "申請",
      "change_image": "更改圖片",
      "copy": "複製",
      "save": "儲存",
      "select_page_helper": "Linking Facebook page(s) means anyone who chats to your bot can see this campaign. For this campaign not to appear on the chatbot, leave this field empty.\nBelow you can see all the messenger interview links to direct candidates directly to the chatbot interview, this is available even if the facebook page is not linked to this campaign (indicated by the lock icon).",
      "view_job_description": "查看工作描述"
    },
    "google": {
      "google_job": "Google Jobs（測試版）",
      "job_par": {
        "best_practice": "最佳做法",
        "first": "刊登於Google的工作將直接顯示在Google搜尋結果中。",
        "head": "啟用Google的登陸頁面索引",
        "help_center": "我們的支援中心",
        "second": "點擊這些職位空缺的申請人將被轉介至Talkpush工作登陸頁面，在那裡他們可以選擇申請並立即完成篩選問題。您可以在此了解更多：",
        "third": "如果您的工作並未出現在Google Job，請確保您有跟從以下"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "必須填寫職位、國家和詳細描述。"
      }
    },
    "landing": {
      "copy": "複製",
      "first": "登陸頁面網址",
      "save": "儲存"
    },
    "lead": {
      "associated": "相關的Facebook專頁",
      "authorize": "您需要將您的Facebook專頁連結至我們的Facebook應用程式（Talkpush機械人），以處理生成的潛在客戶",
      "failed_duplicate": "This Lead Ad ID is already being used by %{campaign}",
      "failed_no_fb_page": "Please associate this company to a facebook page first",
      "how_to": "如何設定Talkpush的主要廣告",
      "id": "主要廣告ID",
      "list": "主要廣告ID清單",
      "login": "以Facebook登入",
      "submit": "提交",
      "success_add": "已成功添加潛在客戶",
      "success_delete": "已刪除添加潛在客戶",
      "title": "主要廣告"
    },
    "spreadsheet": {
      "authorize": "授權訪問",
      "create_par": "建立Google表格",
      "erp": "員工推薦計劃",
      "googlesheet": "Google試算表網址",
      "here": "此處",
      "ncs": "普通候選人提交",
      "paste": "在此貼上您的Google試算表連結。",
      "please": "請輸入與您的Google表格連接的有效的Google試算表網址",
      "step1": "第一步",
      "step2": "第二步",
      "step2_par": "建立一個包含以上Google表格回覆的Google試算表",
      "step3": "第三步",
      "step3_par": "複製Google試算表的網址並貼至下方的欄位，然後點擊授權訪問",
      "step4": "第四步",
      "step4_par": "確認您的Google帳戶憑證以授權Talkpush訪問試算表",
      "title": "試算表",
      "two_ex": "以下是兩個例子",
      "wiki": "維基",
      "wiki_par": "跟隨我們的說明"
    },
    "tecoloco": {
      "job_par": {
        "first": "Jobs that are listed in Tecoloco will appear in the Tecoloco feed.",
        "head": "Advertise the job opening on Tecoloco Jobs",
        "help_center": "我們的支援中心",
        "second": "Candidates who apply to these job listings are forwarded to the Talkpush Job Landing Page, where they can apply and immediately complete the screening questions. You can learn more about it in"
      },
      "tecoloco_jobs": "Tecoloco Jobs"
    }
  },
  "job_landing_page": {
  },
  "jobs": {
    "salary_types": {
      "annually": "Annually",
      "biweekly": "Biweekly",
      "daily": "Daily",
      "hourly": "Hourly",
      "monthly": "Monthly",
      "one-time": "One-time",
      "weekly": "Weekly"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u %n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "HK$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "十億",
          "million": "百萬",
          "quadrillion": "萬億",
          "thousand": "千",
          "trillion": "兆",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy/",
  "setup_questions": {
    "question_types": {
      "audio": "錄音",
      "text": "短篇文字"
    }
  },
  "time": {
    "am": "上午",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%Y年%m月%d日 %A %H:%M:%S %Z",
      "long": "%Y年%m月%d日 %H:%M",
      "short": "%m月%d日 %H:%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "pm": "下午"
  }
});

window.I18n = I18n;
window.t = I18n.t;
window.l = I18n.l;
I18n.locale = document.documentElement.lang;
